export let totalCountTooltipLabel = "CWARYb";
export let totalCountUnreadCountTooltipLabel = "oKHuEe";
export let totalCountsUnreadCountTooltipLabel = "jGYDme";
export let totalCountContextMenuLabel = "Jva5mc";
export let totalCountUnreadCountContextMenuLabel = "ZSUSwd";
export let totalCountsUnreadCountContextMenuLabel = "KhxKXb";
export default {totalCountTooltipLabel,totalCountUnreadCountTooltipLabel,totalCountsUnreadCountTooltipLabel,totalCountContextMenuLabel,totalCountUnreadCountContextMenuLabel,totalCountsUnreadCountContextMenuLabel};